import { isFinite } from 'lodash/fp';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import * as permissionKind from '../../../../shared/permissions';
import { useGetInventoryQuery } from '../../../api/queries/getInventory';
import { useAccount } from '../../../components/contexts/AccountContextManager';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import hasPermissions from '../../../utilities/hasPermissions';
import { InventoryProvider } from '../InventoryDetailsPage/InventoryContext';
import InventoryStockInnerPage from './InventoryStockInnerPage';

const InventoryDetailsPage = () => {
    const { inventoryId, stockId } = useParams<{ inventoryId: string; stockId: string }>();

    const { data, loading } = useGetInventoryQuery({
        fetchPolicy: 'cache-and-network',
        variables: { id: inventoryId },
    });

    const { permissions: accountPermissions } = useAccount();

    const inventory = data?.inventory;

    const [stock, stockNo] = useMemo(() => {
        const stockNo = inventory?.stocks?.findIndex(stock => stock.id === stockId);
        const stock = isFinite(stockNo) && stockNo >= 0 ? inventory.stocks[stockNo] : null;

        return [stock, stockNo + 1];
    }, [inventory, stockId]);

    if (!inventory && loading) {
        return <LoadingElement />;
    }

    if (!inventory || !stock || !hasPermissions(accountPermissions, [permissionKind.viewInventories])) {
        return <NotFoundResult />;
    }

    return (
        <InventoryProvider inventory={inventory}>
            <InventoryStockInnerPage inventory={inventory} stock={stock} stockNo={stockNo} />
        </InventoryProvider>
    );
};

export default InventoryDetailsPage;
